
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.741 5.288a.733.733 0 00-.241.543c0 .206.08.385.241.535l4.143 4.054a.731.731 0 00.53.233.694.694 0 00.52-.201.705.705 0 00.197-.515.68.68 0 00-.21-.499L7.193 7.765 5.696 6.47l1.858.08h10.747a.69.69 0 00.515-.204.71.71 0 00.2-.52c0-.208-.066-.38-.2-.514a.697.697 0 00-.515-.201H7.554l-1.858.072 1.496-1.287 1.73-1.681c.14-.134.209-.3.209-.499 0-.209-.066-.38-.197-.51a.701.701 0 00-.52-.198.744.744 0 00-.53.226L3.741 5.288zm15.043 10.441a.737.737 0 000-1.086l-4.143-4.054a.753.753 0 00-.539-.225c-.21 0-.38.065-.51.197a.691.691 0 00-.198.51c0 .199.067.365.201.5l1.738 1.68 1.496 1.295-1.858-.08H4.224a.711.711 0 00-.519.201.69.69 0 00-.205.515.7.7 0 00.205.523.71.71 0 00.519.2h10.747l1.858-.08-1.496 1.296-1.738 1.673a.704.704 0 00-.2.506c0 .21.065.38.196.511a.69.69 0 00.511.197.753.753 0 00.539-.225l4.143-4.054z","fill":"currentColor"}})])
          )
        }
      }
    